import * as React from 'react';
import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import { OfflineManagerStatus, OfflineManagerState } from '../../containers/OfflineManager/reducer';
import { StyledSplashscreen, LoadingContainer, LoadingRow } from './styles';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import { GalleryInfosState } from '../../containers/Gallery/reducer';
import { FetchStatus } from '../../containers/DriveItemList/reducer';
import { StyleColor } from '../../utils/styles-constants';
const I18n = require('react-redux-i18n').I18n;

export interface LoadingTheme {
	background: string;
	color: string;
	logo: string;
}

interface SplashscreenProps {
	display: boolean;
	loadingTheme: LoadingTheme;
	loadingStatus: string;
	offlineManagerStatus: OfflineManagerStatus;
	offlineManager: OfflineManagerState;
	galleryInfos: GalleryInfosState;
	isMultiApp: boolean;
	isOffline: boolean;
}

class Splashscreen extends React.Component<SplashscreenProps, {}> {

	constructor(props: SplashscreenProps) {
		super(props);
	}

	render() {
		const {
			galleryInfos,
			offlineManager,
			offlineManagerStatus,
			display,
			loadingTheme,
			loadingStatus,
			isMultiApp,
			isOffline,
		} = this.props;
		const isInitError = offlineManagerStatus === OfflineManagerStatus.ERROR;
		const brandLogoUrl = Utils.getBrandLogoUrl(galleryInfos, offlineManager, true, isMultiApp);
		const shouldDisplayLogo = galleryInfos.isLocalTemplateLoaded || galleryInfos.isRemoteTemplateLoaded;

		return (
			<StyledSplashscreen
				className="Splashscreen"
				shouldDisplay={display}
				loadingTheme={loadingTheme}
				data-gallery-slot="splashscreen"
			>
				{shouldDisplayLogo && brandLogoUrl &&
					<img src={brandLogoUrl} alt="" />
				}
				<LoadingContainer>
					{!isInitError && isOffline &&
						<LoadingRow>
							{Utils.getSvgIcon('iconset_loading')}
							<span>{loadingStatus}</span>
						</LoadingRow>
					}
					{!isInitError && !isOffline &&
						<span>{loadingStatus}</span>
					}
				</LoadingContainer>
			</StyledSplashscreen>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, offlineManager, driveList, appInfos } = state;
	const { fetchAllFetchStatus } = driveList;
	const offlineManagerStatus = offlineManager.status;
	const { isDownloadingThumbs, isDownloadingRequiredItems } = offlineManager;
	const { template } = galleryInfos;

	const loadingTheme = {
		background: template && template.applicationSplash && template.applicationSplash.background ? template.applicationSplash.background : StyleColor.White,
		color: template && template.applicationSplash && template.applicationSplash.spinnerWheelColor ? template.applicationSplash.spinnerWheelColor : StyleColor.Black,
		logo: template && template.brand && template.brand.logoHome ? template.brand.logoHome : ''
	};

	let loadingStatus: string;

	if (fetchAllFetchStatus === FetchStatus.FETCHING) {
		loadingStatus = I18n.t('messages.loading_fetch_content');
	} else if (isDownloadingRequiredItems) {
		loadingStatus = I18n.t('messages.loading_required_items');
	} else if (isDownloadingThumbs) {
		loadingStatus = I18n.t('messages.loading_thumbnails');
	} else {
		loadingStatus = I18n.t('messages.loading');
	}

	return {
		galleryInfos,
		loadingTheme,
		offlineManagerStatus,
		offlineManager,
		loadingStatus,
		isMultiApp: Utils.isMultiApp(appInfos),
		isOffline: !UserAgentUtils.isOnline(),
	};
};

export default connect(mapStateToProps)(Splashscreen);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Splashscreen/index.tsx